export default __webpack_public_path__ + "static/media/885.47ee4efb.gif";